<div class="container" style="width: 90%; margin-top: 25px;">  
  <div *ngIf="WUWRatingFormGroup">
    <form [formGroup]="WUWRatingFormGroup" (submit)="onSubmit()">      
      <div style="display: flex;">
       <div style="flex: .6;">
        <div class="mt-3">
          <div class="col-sm-6 col-md-10" *ngFor="let items of weatherRatingInfoFields">
              <hcc-input-generator
              [frmGroup]="WUWRatingFormGroup"
              [fieldInfo]="items.fieldInfo"
              [control]="items.fieldInfo.fieldName"
              [InputConfig]="items?.config"
           ></hcc-input-generator>            
          </div>
          <div class="col-sm-6 col-md-10">
            <div style="margin-left: 74%;" class="container-flex">
              <div class = "div1">
              <a href="javascript:void(0);" id="btnRemoveEventDates" class="limitbtn" type="button" (click)="RemoveEventDates($event)" hidden>Remove</a>
              </div>
              <div class = "div1">
              <a href="javascript:void(0);" id="btnAddEventDates" class="limitbtn" type="button" (click)="AddEventDates($event)">Add More</a>                               
              </div>
            </div>
          </div>
           <div class="col-sm-6 col-md-10">
            <div style="display: flex;">
              <div style="flex: .25">
                <label>
                  Rain Peril
                </label>
              </div>
              <div style="flex: 1">
                <div class="form-row">
                  <div style="display: flex;">
                    <div style="flex: .5">
                      <div style="padding-left: 0px;" class="col-sm-10 col-md-10" *ngFor="let items of thresholdConfigInfoFields">
                          <hcc-input-generator
                          [frmGroup]="WUWRatingFormGroup"
                          [fieldInfo]="items.fieldInfo"
                          [control]="items.fieldInfo.fieldName"
                          [InputConfig]="items?.config"
                          ></hcc-input-generator>
                      </div>
                      <a href="javascript:void(0);" id="btnAddThreshold" class="limitbtn" type="button" (click)="AddThreshold($event)">Add More</a>                      
                    </div>
                    <div style="flex: .5">
                      <div style="padding-left: 0px;" class="col-sm-10 col-md-10" *ngFor="let items of limitConfigInfoFields">
                          <hcc-input-generator
                          [frmGroup]="WUWRatingFormGroup"
                          [fieldInfo]="items.fieldInfo"
                          [control]="items.fieldInfo.fieldName"
                          [InputConfig]="items?.config"
                          ></hcc-input-generator>
                      </div>
                      <a href="javascript:void(0);" id="btnAddLimit" class="limitbtn" type="button" (click)="AddLimit($event)">Add More</a>                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
      <div class="row text-right mt-5 mb-4">
          <div class="col-md-3"></div> 
            <div class="col-md-3">
              <button
                [disabled]="false"
                class="btn btn-primary w-100"
                type="submit"                                 
              >
                Send
              </button>
            </div>                    
        </div>
        </div>
         <div style="flex: .43;" *ngIf="costsResponseData.length > 0">
           <div class="row mt-3 border">
             <div style="margin: 2px 0px 0px 5px; width: 21%;"><b>Threshhold</b></div>
             <div style="margin: 2px 0px 0px 3px; width: 17%;"><b>Limit</b></div>
             <div style="margin: 2px 0px 0px 3px; width: 17%;"><b>Cost</b></div>
             <div style="margin: 2px 0px 0px 3px; width: 40%;"><b>Event Period</b></div>
           </div>          
           <div class="row border" *ngFor="let items of costsResponseData; let i = index">
             <div style="margin: 2px 0px 0px 5px; width: 21%;">{{items.threshold}}</div>
             <div style="margin: 2px 0px 0px 3px; width: 17%;">{{items.limit}}</div>
             <div style="margin: 2px 0px 0px 3px; width: 17%;">{{items.cost}}</div>
             <div style="margin: 2px 0px 0px 3px; width: 40%;">{{items.eventPeriod}}</div>
           </div>           
        </div>
      </div>    
    </form>
  </div>
</div>
